/**
 * A regex object to validate longitudes
 */
export const LONGITUDE_REGEX = /^[-+]?(?:180(?:\.0+)?|(?:(?:1[0-7]\d)|(?:[1-9]?\d))(?:\.\d+)?)$/;
